module.exports = __webpack_public_path__ + "static/media/facility-icon.bd0f8989.svg";